module.exports = function () {
  var help = "";
  var advice = "";
  var html = "\n      <div class=\"vp-overlay\" id=\"vp-overlay\">\n\t<div class=\"help\">".concat(help, "</div>\n\t<div class=\"factions\"></div>\n\t<div class=\"advice\">").concat(advice, "</div>\n      </div>\n  ");
  return html;
};